// @flow
import type { SetHandicappingStoreModalHeaderAction } from "@tvg/shared-actions/HandicappingStore";
import type {
  AccountWalletOpenModalAction,
  AccountWalletCloseModalAction
} from "@tvg/sh-lib-account-wallet/src/redux/types";
import type { TransactionsHistoryModalActions } from "@urp/transaction-history/src/redux/types";

import type { Actions } from "../../actions/modals";

export type PotentialReturnParentPage = "programPage" | "myBets";

export type State = {
  promosOpen: boolean,
  handicappingStore: {
    isOpen: boolean,
    isModalHasHeader: boolean,
    url: string
  },
  isModalOpen: boolean,
  navigationOpen: boolean,
  betPreferencesOpen: boolean,
  termsContent: string,
  isSightlineRedirectModalOpen: boolean,
  featureTogglesOpen: boolean,
  geoComplyErrorOpen: boolean,
  trackSelectorOpen: boolean,
  helpModalOpen: boolean,
  supportOpen: boolean,
  welcomeNewUserOpen: boolean,
  potencialReturn: {
    isOpen: boolean,
    hasMessage: boolean,
    parentPage: PotentialReturnParentPage
  },
  accountWallet: {
    open: boolean,
    title: string,
    path: string
  },
  isInvalidResidentialAddressModalOpen: boolean,
  isCrossProductNavigationModalOpen: boolean,
  isFullscreenVideoOpen: boolean
};

export const initialState = {
  promosOpen: false,
  isModalOpen: false,
  navigationOpen: false,
  geoComplyErrorOpen: false,
  betPreferencesOpen: false,
  featureTogglesOpen: false,
  trackSelectorOpen: false,
  handicappingStore: {
    isOpen: false,
    isModalHasHeader: true,
    url: ""
  },
  isSightlineRedirectModalOpen: false,
  termsContent: "",
  supportOpen: false,
  welcomeNewUserOpen: false,
  helpModalOpen: false,
  potencialReturn: {
    isOpen: false,
    hasMessage: false,
    parentPage: "programPage"
  },
  accountWallet: {
    open: false,
    title: "Account",
    path: "account"
  },
  isInvalidResidentialAddressModalOpen: false,
  isCrossProductNavigationModalOpen: false,
  isFullscreenVideoOpen: false,
  isTransactionHistoryModalOpen: false
};

const modalReducer = (
  state: State = initialState,
  action:
    | Actions
    | SetHandicappingStoreModalHeaderAction
    | AccountWalletCloseModalAction
    | AccountWalletOpenModalAction
    | TransactionsHistoryModalActions
): State => {
  switch (action.type) {
    case "OPEN_PROMOS_MODAL": {
      return { ...state, promosOpen: true, isModalOpen: true };
    }
    case "CLOSE_PROMOS_MODAL": {
      return { ...state, promosOpen: false, isModalOpen: false };
    }
    case "OPEN_NAVIGATION_MODAL": {
      return {
        ...state,
        navigationOpen: true,
        termsContent: action.payload,
        isModalOpen: true
      };
    }
    case "CLOSE_NAVIGATION_MODAL": {
      return {
        ...state,
        navigationOpen: false,
        termsContent: action.payload,
        isModalOpen: false
      };
    }
    case "OPEN_BET_PREFERENCES_MODAL": {
      return { ...state, betPreferencesOpen: true, isModalOpen: true };
    }
    case "CLOSE_BET_PREFERENCES_MODAL": {
      return { ...state, betPreferencesOpen: false, isModalOpen: false };
    }
    case "OPEN_FEATURE_TOGGLES_MODAL": {
      return { ...state, featureTogglesOpen: true, isModalOpen: true };
    }
    case "CLOSE_FEATURE_TOGGLES_MODAL": {
      return { ...state, featureTogglesOpen: false, isModalOpen: false };
    }
    case "OPEN_TRACK_SELECTOR_MODAL": {
      return { ...state, trackSelectorOpen: true, isModalOpen: true };
    }
    case "CLOSE_TRACK_SELECTOR_MODAL": {
      return { ...state, trackSelectorOpen: false, isModalOpen: false };
    }
    case "OPEN_RACE_SELECTOR_MODAL": {
      return { ...state, raceSelectorOpen: true, isModalOpen: true };
    }
    case "CLOSE_RACE_SELECTOR_MODAL": {
      return { ...state, raceSelectorOpen: false, isModalOpen: false };
    }
    case "OPEN_HELP_MODAL": {
      return { ...state, helpModalOpen: true, isModalOpen: true };
    }
    case "CLOSE_HELP_MODAL": {
      return { ...state, helpModalOpen: false, isModalOpen: false };
    }
    case "GEOCOMPLY_ERROR_MODAL": {
      return {
        ...state,
        geoComplyErrorOpen: !state.geoComplyErrorOpen,
        isModalOpen: !state.isModalOpen
      };
    }
    case "OPEN_HANDICAPPING_STORE_MODAL": {
      return {
        ...state,
        handicappingStore: {
          ...state.handicappingStore,
          isOpen: true
        },
        isModalOpen: true
      };
    }
    case "CLOSE_HANDICAPPING_STORE_MODAL": {
      return {
        ...state,
        handicappingStore: {
          ...state.handicappingStore,
          isOpen: false,
          url: ""
        },
        isModalOpen: false
      };
    }
    case "OPEN_SUPPORT_MODAL": {
      return { ...state, supportOpen: true, isModalOpen: true };
    }
    case "CLOSE_SUPPORT_MODAL": {
      return { ...state, supportOpen: false, isModalOpen: false };
    }
    case "OPEN_WELCOME_NEW_USER_MODAL": {
      return { ...state, welcomeNewUserOpen: true, isModalOpen: true };
    }
    case "CLOSE_WELCOME_NEW_USER_MODAL": {
      return { ...state, welcomeNewUserOpen: false, isModalOpen: false };
    }
    case "SET_HANDICAPPING_STORE_MODAL_URL": {
      return {
        ...state,
        handicappingStore: {
          ...state.handicappingStore,
          url: action.payload.url
        },
        isModalOpen: false
      };
    }
    case "SET_HANDICAPPING_STORE_MODAL_HEADER": {
      return {
        ...state,
        handicappingStore: {
          ...state.handicappingStore,
          isModalHasHeader: action.payload.isModalHasHeader
        }
      };
    }
    case "OPEN_POTENCIAL_RETURN_MODAL": {
      return {
        ...state,
        potencialReturn: {
          isOpen: true,
          hasMessage: action.payload.hasMessage,
          parentPage: action.payload.parentPage
        },
        isModalOpen: true
      };
    }
    case "CLOSE_POTENCIAL_RETURN_MODAL": {
      return {
        ...state,
        potencialReturn: {
          ...state.potencialReturn,
          isOpen: false
        },
        isModalOpen: false
      };
    }
    case "OPEN_PICK_BETS_HOW_IT_WORKS_MODAL": {
      return {
        ...state,
        isPickBetsModalOpen: true,
        isModalOpen: true
      };
    }
    case "CLOSE_PICK_BETS_HOW_IT_WORKS_MODAL": {
      return {
        ...state,
        isPickBetsModalOpen: false,
        isModalOpen: false
      };
    }
    case "OPEN_AW_MODAL": {
      return {
        ...state,
        accountWallet: {
          ...state.accountWallet,
          open: true,
          title: action.payload.title,
          path: action.payload.path
        },
        isModalOpen: true
      };
    }
    case "CLOSE_AW_MODAL": {
      return {
        ...state,
        accountWallet: {
          ...state.accountWallet,
          open: false
        },
        isModalOpen: false
      };
    }
    case "OPEN_INVALID_RESIDENTIAL_ADDRESS_MODAL": {
      return {
        ...state,
        isInvalidResidentialAddressModalOpen: true,
        isModalOpen: true
      };
    }
    case "CLOSE_INVALID_RESIDENTIAL_ADDRESS_MODAL": {
      return {
        ...state,
        isInvalidResidentialAddressModalOpen: false,
        isModalOpen: false
      };
    }
    case "OPEN_CROSS_PRODUCT_NAVIGATION_MODAL": {
      return {
        ...state,
        isCrossProductNavigationModalOpen: true,
        isModalOpen: true
      };
    }
    case "CLOSE_CROSS_PRODUCT_NAVIGATION_MODAL": {
      return {
        ...state,
        isCrossProductNavigationModalOpen: false,
        isModalOpen: false
      };
    }
    case "OPEN_FULLSCREEN_VIDEO_MODAL": {
      return {
        ...state,
        isFullscreenVideoOpen: true,
        isModalOpen: true
      };
    }
    case "CLOSE_FULLSCREEN_VIDEO_MODAL": {
      return {
        ...state,
        isFullscreenVideoOpen: false,
        isModalOpen: false
      };
    }
    case "OPEN_TRANSACTION_HISTORY_MODAL": {
      return {
        ...state,
        isTransactionHistoryModalOpen: true,
        isModalOpen: true
      };
    }
    case "CLOSE_TRANSACTION_HISTORY_MODAL": {
      return {
        ...state,
        isTransactionHistoryModalOpen: false,
        isModalOpen: false
      };
    }
    case "CLOSE_ALL_MODALS": {
      return {
        ...state,
        promosOpen: false,
        handicappingStore: {
          ...state.handicappingStore,
          isOpen: false
        },
        isModalOpen: false,
        navigationOpen: false,
        betPreferencesOpen: false,
        featureTogglesOpen: false,
        trackSelectorOpen: false,
        raceSelectorOpen: false,
        supportOpen: false,
        welcomeNewUserOpen: false,
        isFullscreenVideoOpen: false
      };
    }
    default: {
      return state;
    }
  }
};

export default modalReducer;
